<!-- Addresses Page -->
<div class="ks-page-table space-y-6">
  <!-- Error Message -->
  @if (error()) {
  <app-inline-notice tone="error" [message]="error()" />
  }

  <!-- Bulk selection toolbar -->
  @if (selectedAddressIds().length > 0 && currentOrgStore.can('organization', 'createcampaign')) {
  <div
    class="flex items-center justify-between gap-3 px-4 py-2.5 rounded-lg border bg-primary/5 border-primary/20"
  >
    <span class="text-sm font-normal text-primary">
      {{ selectedAddressIds().length }}
      {{ selectedAddressIds().length === 1 ? "Adresse" : "Adressen" }} ausgewählt
    </span>
    <button
      hlmBtn
      size="sm"
      (click)="onCreateCampaignFromSelection()"
      class="flex items-center gap-1.5"
    >
      <ng-icon name="lucideRocket" class="w-4 h-4"></ng-icon>
      Kampagne erstellen
    </button>
  </div>
  }

  <!-- Address Table -->
  @if (organizationId()) {
  <app-address-table #addressTable
    [addresses]="addresses()"
    [isLoading]="isLoading()"
    [showSelectionColumn]="currentOrgStore.can('organization', 'createcampaign')"
    [organizationId]="organizationId()"
    [serverSorting]="true"
    (sortChange)="onSortChange($event)"
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    [totalItems]="totalAddresses()"
    [isSelectingAll]="isSelectingAll()"
    (pageChange)="onPageChange($event)"
    (addressCreated)="onAddressCreated($event)"
    (addressUpdated)="onAddressUpdated($event)"
    (dataChanged)="loadAddresses()"
    (selectionChanged)="onSelectionChanged($event)"
    (createCampaignRequested)="onCreateCampaignRequested($event)"
    (requestSelectAll)="onRequestSelectAll()"
  />
  }
</div>

<!-- Campaign creation dialog (opened imperatively via viewChild) -->
@if (organizationId()) {
<app-create-campaign-dialog
  #campaignDialog
  [organizationId]="organizationId()"
  (submitted)="onCampaignCreated($event)"
/>
}
